var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "template-mapping" }, [
    _c(
      "main",
      { staticClass: "message" },
      [
        _c(
          "b-card",
          { attrs: { "header-tag": "header", "footer-tag": "footer" } },
          [
            _c("div", { attrs: { slot: "header" }, slot: "header" }, [
              _c("i", { attrs: { className: "fa fa-align-justify" } }),
              _c("strong", [_vm._v(_vm._s(this.$t("TEMPLATE.MAPPINGS")))])
            ]),
            _vm._v(" "),
            _c(
              "b-list-group",
              { style: { maxHeight: this.containerHeight + "px" } },
              [
                _vm.blankTemplateMappings
                  ? _c(
                      "div",
                      [
                        _c("b-card", [
                          _vm._v("\n          No mappings added\n        ")
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "map-tree", attrs: { role: "tablist" } },
                  [
                    _c("v-tree", {
                      ref: "tree",
                      attrs: {
                        data: this.templateMappings,
                        tpl: _vm.customTemplate
                      }
                    })
                  ],
                  1
                )
              ]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e62041a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e62041a2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/templates/templateMappings.vue
// module id = 1111
// module chunks = 2